import { apiForPrivate } from '.';
import { CLIENT_ENDPOINT } from '../../config/ap';

const apiClients = apiForPrivate.injectEndpoints({
    overrideExisting: true,
    endpoints: build => ({
        getClient: build.query({
            query: id => `${CLIENT_ENDPOINT.CLIENTS}/${id}`,
        }),
        getClients: build.query({
            query: page => ({
                url: `${CLIENT_ENDPOINT.CLIENTS}`,
                params: page
            })
        }),
        getClientNames: build.query({
            query: () => `${CLIENT_ENDPOINT.CLIENTS}/names`,
        }),
        addClient: build.mutation({
            query: payload => ({
                url: CLIENT_ENDPOINT.CLIENTS,
                method: 'POST',
                body: payload,
            }),
        }),
        updateClient: build.mutation({
            query: ({ id, payload }) => ({
                url: `${CLIENT_ENDPOINT.CLIENTS}/${id}`,
                method: 'PUT',
                body: payload,
            }),
        }),
        copyClient: build.mutation({
            query: payload => ({
                url: `${CLIENT_ENDPOINT.CLIENTS}/copy`,
                method: 'POST',
                body: payload,
            }),
        }),
        deleteClient: build.mutation({
            query: payload => ({
                url: `${CLIENT_ENDPOINT.CLIENTS}/${payload.id}`,
                method: 'DELETE'
            }),
        }),
        scheduleClient: build.mutation({
            query: id => ({
                url: `${CLIENT_ENDPOINT.SCHEDULE_CLIENTS}/${id}`,
                method: 'POST',
            }),
        }),
        unscheduleClient: build.mutation({
            query: id => ({
                url: `${CLIENT_ENDPOINT.UNSCHEDULE_CLIENTS}/${id}`,
                method: 'POST',
            }),
        }),
        exportClient: build.query({
            query: id => ({
                url: `${CLIENT_ENDPOINT.CLIENTS}/${id}/export`,
                responseHandler: (response: any) => response.blob(),
            }),
        }),
        importClient: build.mutation({
            query: ({ file, overwrite = false, clientGroupId }: { file: File; overwrite: boolean; clientGroupId?: number }) => {
                const formData = new FormData();
                formData.append('file', file);
                const params: any = { overwrite };
                if (clientGroupId !== undefined) params.clientGroupId = clientGroupId;
                return {
                    url: `${CLIENT_ENDPOINT.CLIENTS}/import`,
                    method: 'POST',
                    params,
                    body: formData,
                };
            },
        }),
    })
});

export const {
    useLazyGetClientQuery,
    useLazyGetClientsQuery,
    useGetClientNamesQuery,
    useAddClientMutation,
    useUpdateClientMutation,
    useDeleteClientMutation,
    useCopyClientMutation,
    useScheduleClientMutation,
    useUnscheduleClientMutation,
    useLazyExportClientQuery,
    useImportClientMutation,
} = apiClients;